module.exports = __webpack_public_path__ + "static/media/not-found.985485ef.jpg";